/** Created by azhou on 2018/7/24.*/
<template>
  <div class="text-left">
    <h5>关于隐私政策</h5>
    <p>
      订单雨平台将竭力保证每一位用户的个人信息隐私，包括注册信息，上传图片信息和其他各类编辑信息。订单雨绝不会在没有征求用户同意的情况下对用户信息进行技术分析后用于第三方获取利益。在使用"www.dingdanyu.com"的时候，请先阅读隐私条款，在您注册成为会员的时候即表示您确认并同意了我们的隐私政策。
    </p>
    <h5>隐私政策细则</h5>
    <p>1. 账户信息的隐私</p>
    <p>当您注册后，平台会自动分配给您一个帐户，包括您的个人信息、单张订单信息，历史订单信息、积分等项目，你可以对这些相关信息进行查看或者编辑。您的帐户信息将不会被泄露，以下特殊情况除外：法院、公安机关、检察机关或者国家其他相关机构按照国家法律表明正当需要并通过正常手续要求获取某账户指定信息时。您存储在平台中的一切信息都将会被妥善保存，在没有得到您的授权之前，任何人、任何单位都没有权利也不能够查看、编辑或者删除您的信息。</p>
    <p>2. 订单信息的隐私</p>
    <p>当您使用订单雨提交订单成功后，您的订单信息将会被妥善保管。未经您的许可，所有和您订单不相关的个人或者酒店方都将无法看到您的订单信息。</p>
    <p>3. 其他</p>
    <p>我们强烈建议您妥善保存自己的帐号及密码信息，如果因为您的个人原因泄露或者遗失帐号信息和密码，我们将不承担任何责任。</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    components: {}
  }
</script>
<style lang="scss" scoped>
  h5{font-weight: bold}
  p{ color: #aaa;}
</style>
